import { useState } from 'react';
import axios from 'axios';
import { Mail, Send, CheckCircle2 } from 'lucide-react';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function Contacto() {
  const [form, setForm] = useState({ nombre: '', email: '', empresa: '', telefono: '', mensaje: '' });
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState('');

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API}/contacto`, form);
      setEnviado(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'No se pudo enviar el mensaje. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="legal-page font-sans min-h-screen bg-slate-50">
      <div className="max-w-xl mx-auto px-6 py-16">
        <a href="/" className="text-sm text-brand-blue font-medium">&larr; Volver a Conciliabanco</a>

        <h1 className="text-3xl font-extrabold text-navy-900 mt-4 mb-2">Contáctanos</h1>
        <p className="text-slate-600 mb-8">
          Cuéntanos qué necesitas y te respondemos lo antes posible.
        </p>

        {enviado ? (
          <div className="rounded-2xl border border-brand-green/30 bg-green-50 p-8 text-center">
            <CheckCircle2 size={32} className="mx-auto text-brand-green mb-3" />
            <p className="font-semibold text-navy-900">Mensaje enviado</p>
            <p className="text-sm text-slate-600 mt-1">Gracias por escribirnos, te responderemos pronto.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="rounded-2xl border border-slate-200 bg-white p-7 space-y-4">
            <div className="grid sm:grid-cols-2 gap-4">
              <input
                name="nombre" required placeholder="Nombre *" value={form.nombre} onChange={handle}
                className="w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm outline-none focus:border-brand-blue"
              />
              <input
                name="email" type="email" required placeholder="Correo *" value={form.email} onChange={handle}
                className="w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm outline-none focus:border-brand-blue"
              />
            </div>
            <div className="grid sm:grid-cols-2 gap-4">
              <input
                name="empresa" placeholder="Empresa" value={form.empresa} onChange={handle}
                className="w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm outline-none focus:border-brand-blue"
              />
              <input
                name="telefono" placeholder="Teléfono" value={form.telefono} onChange={handle}
                className="w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm outline-none focus:border-brand-blue"
              />
            </div>
            <textarea
              name="mensaje" required minLength={5} maxLength={5000} rows={5} placeholder="¿En qué te podemos ayudar? *"
              value={form.mensaje} onChange={handle}
              className="w-full rounded-lg border border-slate-200 px-4 py-2.5 text-sm outline-none focus:border-brand-blue resize-none"
            />

            {error && <p className="text-sm text-red-600">{error}</p>}

            <button
              type="submit" disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-brand-green py-3 font-semibold text-white hover:bg-brand-greenDark transition-colors disabled:opacity-60"
            >
              {loading ? 'Enviando...' : <>Enviar mensaje <Send size={16} /></>}
            </button>

            <p className="flex items-center justify-center gap-1.5 text-xs text-slate-400 pt-1">
              <Mail size={13} /> o escríbenos directo a concilia@conciliabanco.com
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
